import { baseEmailMessageModel } from './email_message';

const EmailCampaignOutreach = baseEmailMessageModel('EmailCampaignOutreach', { campaignId: String });

export default EmailCampaignOutreach;
